import Oge from './index'
const Resource = () => {
	return <Oge id="resource" url="resourceCenter" type="dataset" />
}
export default Resource;